import { render, staticRenderFns } from "./Celebration.vue?vue&type=template&id=4c24d01c&scoped=true"
import script from "./Celebration.vue?vue&type=script&lang=js"
export * from "./Celebration.vue?vue&type=script&lang=js"
import style0 from "./Celebration.vue?vue&type=style&index=0&id=4c24d01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24d01c",
  null
  
)

export default component.exports